module.exports = __webpack_public_path__ + "static/media/meme_2.9daef0fe.jpg";